import * as z from "zod";

import { additionalDataSchema } from "./additional-field";
import { surrealRecordSchema } from "./surreal-record";

export const organizationSchema = surrealRecordSchema.extend({
  corporateRegistrationNumber: z.string(),
  name: z.string().optional(),
  email: z.string().optional(),
  phone: z.string().optional(),
  additionalData: additionalDataSchema,
});
export const organizationCreateSchema = organizationSchema.omit({ id: true });
export const organizationUpdateSchema = organizationCreateSchema.partial();

export type Organization = z.infer<typeof organizationSchema>;

export function getOrganizationSchemaAdditionalFields(additionalFields: {
  organization: typeof additionalDataSchema;
}): typeof organizationSchema {
  return organizationSchema.extend({
    additionalData: additionalFields.organization,
  });
}
